import React from 'react';
import { NotificationService } from 'services';
import moment from 'moment';

interface Props {
  item?: any;
}

class ViewDetail extends React.Component<Props> {
  state = {
    detail: null,
    recipients: [],
    page: 1,
    last_page: 1,
  };

  componentDidMount() {
    this.load();
    this.loadRecipients();
  }

  load = async () => {
    const res: any = await NotificationService.admin.detail({
      id: this.props.item?.id,
      withoutLoading: true,
    });
    this.setState({ detail: res.notification ?? res });
  };

  loadRecipients = async (withoutLoading: boolean = false) => {
    const res: any = await NotificationService.admin.recipients({
      id: this.props.item?.id,
      page: this.state.page,
      withoutLoading,
    });
    this.setState({
      recipients: res.recipients?.rows ?? [],
      last_page: res.recipients?.count ?? 1,
    });
  };

  render() {
    const detail: any = this.state.detail;

    return (
      <div id='admin-view-notification'>
        <div className='container-detail'>
          <p className='subject'>{detail?.subject}</p>
          <p className='description'>{detail?.description}</p>
          {/* detail() devuelve `images`: array ya con `url` resuelta (no un campo `image` único). */}
          {(detail?.images || []).map((img: any) => (
            <img key={img.id} className='notification-image' src={img.url} />
          ))}
          {detail?.created_at && moment(detail.created_at).isValid() && (
            <p className='date'>{moment(detail.created_at).format('DD/MM/YYYY HH:mm')}</p>
          )}

          <h4>Destinatarios</h4>
          {this.state.recipients.map((r: any) => {
            // recipients() no trae full_name; se arma con name + lastname. El campo
            // de lectura es `read_at` (timestamp o null), no un booleano `read`.
            const fullName = `${r.user?.name || ''} ${r.user?.lastname || ''}`.trim();
            return (
              <div className='recipient-row' key={r.id}>
                <span>{fullName}</span>
                <span className={r.read_at ? 'read' : 'unread'}>
                  {r.read_at ? 'Leído' : 'No leído'}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ViewDetail;
